import { AuthError } from "@azure/msal-browser";
import { msalInstance, apiRequest } from "../authConfig";
import { getEnv } from "./runtimeEnv";

export class ApiError extends Error {
  constructor(status, message, details) {
    super(message);
    this.status = status;
    this.details = details;
  }
}

const BASE_URL = getEnv("REACT_APP_API_URL") || "http://localhost:3001/api";

async function getAccessToken() {
  const account = msalInstance.getAllAccounts()[0];
  try {
    const result = await msalInstance.acquireTokenSilent({
      ...apiRequest,
      account,
    });
    return result.accessToken;
  } catch (e) {
    if (e instanceof AuthError) {
      await msalInstance.logoutRedirect();
      return;
    }
    throw e;
  }
}

async function request(path, options = {}) {
  const token = await getAccessToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new ApiError(
      res.status,
      body?.error?.message || res.statusText,
      body?.error?.details,
    );
  }
  return res.status === 204 ? null : res.json();
}

export const api = {
  get: (path) => request(path),
  post: (path, body) =>
    request(path, { method: "POST", body: JSON.stringify(body) }),
  patch: (path, body) =>
    request(path, { method: "PATCH", body: JSON.stringify(body) }),
  put: (path, body) =>
    request(path, { method: "PUT", body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: "DELETE" }),
};
